'use strict';

angular.module('msCore').directive('msOverlay', [function () {
  return {
    templateUrl: function templateUrl(ele, attr) {
      return attr.onboarding ? 'core/templates/overlayOnboarding.html' : 'core/templates/overlay.html';
    },
    replace: true,
    restrict: 'AE',
    controller: 'OverlayCtrl',
    link: function link(scope, element) {
      element.find('.animateOut,.exit-animation').bind('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function () {
        scope.hide();
      });
    }
  };
}]).controller('OverlayCtrl', ['$scope', '$timeout', '$state', '$translate', '$injector', 'overlaySvc', function ($scope, $timeout, $state, $translate, $injector, overlaySvc) {
  // boolean to see if we should be displaying the overlay at all
  $scope.show = false;
  // the overlay information (title ect)
  $scope.overlay = {};
  // hides the overlay (and triggers the next state if there is one)
  $scope.hide = hide;
  // timer to keep track of automatic redirection
  var timer, overlayTimer;
  /**
   * Display the overlay.
   * @param  {object} overlay  The overlay object, which should have the title, content and current step
   * @param  {string} redirect The ui router location to redirect to once the overlay is done
   * @param  {integer} timeout The amount of time before the redirect should be triggered (defaults to 1500ms)
   * @param  {integer} overlayTimeout The amount of time before the overlay should be hidden (defaults to 0s)
   */
  function display(overlay, redirect, timeout, overlayTimeout, callback) {
    $scope.show = true;

    if (overlay.dataModel) {
      $scope.dataModel = overlay.dataModel;
      $scope.template = overlay.template;
      $scope.callback = function () {
        callback();
      };
    } else {
      $translate([overlay.prefix + '.subtitle', overlay.prefix + '.title', overlay.prefix + '.content']).then(function (res) {
        $scope.showSubtitle = res[overlay.prefix + '.subtitle'] !== overlay.prefix + '.subtitle';
        $scope.showContent = res[overlay.prefix + '.content'] !== overlay.prefix + '.content';
        $scope.overlay = overlay;
      });
      if (overlayTimeout) {
        overlayTimer = $timeout(function () {
          hideOverlayOnly();
        }, overlayTimeout);
      }
      if (timeout) {
        timer = $timeout(function () {
          hide(overlay.options.args);
        }, timeout);
        if (redirect) {
          timer.redirect = redirect;
        }
      }
    }
  }
  /**
   * Hide the overlay and redirect if possible
   */
  function hideOverlayOnly() {
    if (overlayTimer) {
      $timeout.cancel(overlayTimer);
    }
    $scope.show = false;
  }
  /**
   * Hide the overlay and redirect if possible
   */
  function hide(args) {
    if (timer) {
      $timeout.cancel(timer);
      if (timer.redirect) {
        $state.go(timer.redirect, args);
      }
    }
    if (!overlayTimer) {
      $scope.show = false;
    }
    $scope.dataModel = null;
    $scope.template = null;
  }

  overlaySvc.setCallback(display);
}]);